exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-cfc28dfe] {\n\tborder-collapse: collapse;\n}\ntd[data-v-cfc28dfe], th[data-v-cfc28dfe] {\n\tborder-spacing: 0;\n}\n.edit-bar[data-v-cfc28dfe] {\n\tmargin:10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cfc28dfe","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/layout_7.vue
// module id = 773
// module chunks = 0